import * as React from 'react';
import styles from './index.less';
import { Pagination } from 'antd';
import FModal from '@/components/FModal';
import FIcons from '@/components/FIcons';

export interface FPodcastRssSyncErrorModalProps {
  open: boolean;
  onClose: () => void;
  // 全部错误文案
  messages: string[];
  pageSize?: number;
}

function FPodcastRssSyncErrorModal({
  open,
  onClose,
  messages,
  pageSize = 20,
}: FPodcastRssSyncErrorModalProps) {
  const [$current, set$current] = React.useState<number>(1);

  React.useEffect(() => {
    if (open) {
      set$current(1);
    }
  }, [open]);

  const total = messages.length;
  const pageMessages = messages.slice(($current - 1) * pageSize, $current * pageSize);

  return (
    <FModal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={760}
      centered
      styles={{ content: { padding: 0 } }}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <span className={styles.title}>RSS 订阅信息异常</span>
          <FIcons.FClose className={styles.close} onClick={onClose} />
        </div>

        <div className={styles.body}>
          <div className={styles.list}>
            {pageMessages.map((message, index) => (
              <div key={($current - 1) * pageSize + index} className={styles.line}>
                {message}
              </div>
            ))}
          </div>

          {total > pageSize && (
            <div className={styles.pager}>
              <Pagination
                size='small'
                showSizeChanger={false}
                current={$current}
                pageSize={pageSize}
                total={total}
                onChange={(page) => {
                  set$current(page);
                }}
                showTotal={(t) => `共${t}条`}
              />
            </div>
          )}
        </div>
      </div>
    </FModal>
  );
}

export default FPodcastRssSyncErrorModal;
